import { requestFactory } from './index';
const request = requestFactory('/api/marketing');
export function getExistPromotionCode(code) {
    //auth  marketing:existPromotionCode
    return request({
        method: 'get',
        url: '/discount/existPromotionCode',
        params: { code },
    });
}
